<template>
  <source-dialog-view
    v-if="visible"

    ref="dialogView"
    :content="content"
    :action="action"

    @set-content="setContent"
    @add-complete="onAddComplete"
    @edit-complete="onEditComplete"

    @close="visible = false"
  ></source-dialog-view>
</template>

<script>
import { mapActions } from 'vuex'
import { mapState } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

import { getDefaultSourceData } from '@/shared/defaults.js'

export default {
  components: {
    SourceDialogView: require('./SourceDialogView.vue')
  },
  props: {
  },
  data () {
    return {
      visible: false,
      action: null,
      content: null,
      editSourceId: null
    }
  },
  computed: {
    ...mapState({
      links: state => state.links,
      sources: state => state.sources
    })
  },
  methods: {
    ...mapActions(['addSource', 'addLink', 'editSource']),
    reset () {
      this.content = getDefaultSourceData()
    },
    add () {
      this.action = 'add'
      this.content = getDefaultSourceData()

      this.open()
    },
    edit (linkId) {
      this.action = 'edit'
      const link = this.links[linkId]
      // TODO add multiple sources links support
      this.editSourceId = _.head(link.sources)
      const source = this.sources[this.editSourceId]
      this.content = _.cloneDeep(source)

      this.open()
    },
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dialogView.open()
      })
    },
    setContent (values) {
      this.content = {...values}
    },
    onAddComplete () {
      this.addSource({content: this.content}).then((sourceId) => {
        return this.addLink({sourceId})
      }).then((linkId) => {
        this.$emit('add-link', linkId)
      }).catch((err) => {
        this.handleError(err)
      })
    },
    onEditComplete () {
      this.editSource({content: this.content, sourceId: this.editSourceId}).catch((err) => {
        this.handleError(err)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// SourceDialogContainer.vue?04398aed